import { domEvents, withPlugins } from '@spon/plugins'

function Search({ node, plugins: { addEvents } }) {
	const $searchField = document.querySelector('.js-searchbar-field')
	// const $siteBody = document.querySelector('.site-page')
	let isOpen = null

	function onClick(e) {
		e.preventDefault()

		if (!isOpen) {
			// open it
			node.classList.add('is-active')
			$searchField.focus()
		} else {
			// close it
			if ($searchField.value !== '') {
				// run search
				node.submit()
			} else {
				// IS EMPTY, CLOSE IT
				node.classList.remove('is-active')
			}
		}

		isOpen = !isOpen
	}

	addEvents({
		'click .js-searchbar-btn': onClick
	})

	return () => {
		// $el.classList.remove('is-active')
	}
}

export default withPlugins(domEvents)(Search)
